import AppInfoComponentResourceModel from '../../generated/types/model/resource/AppInfoComponentResourceModel';

export default class AppInfoComponentResourceViewModel extends AppInfoComponentResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
